import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const OrganizationDeleted = () => {
  const { logout, isLoading } = useAuth0();
  const navigate = useNavigate();

  // Show loading state while Auth0 is processing
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  const handleSignOut = () => {
    // Clear any potential returnTo state that might cause redirects
    sessionStorage.removeItem('auth0_returnTo');
    
    // Set flag to prevent auto-organization creation after deletion
    sessionStorage.setItem('skip_org_creation', 'true');
    
    logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  };

  const handleNewOrganization = () => {
    navigate('/onboarding');
  };

  const handleReturnHome = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
            <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Organization Successfully Deleted
          </h3>
          <p className="text-sm text-gray-500 mb-6">
            Your organization has been permanently deleted. You can now choose to:
          </p>
          <div className="flex flex-col gap-3">
            <button
              onClick={handleSignOut}
              className="w-full bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
            >
              Sign Out & Return to Login
            </button>
            <button
              onClick={handleNewOrganization}
              className="w-full bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition-colors"
            >
              Set Up New Organization
            </button>
            <button
              onClick={handleReturnHome}
              className="w-full bg-gray-200 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-300 transition-colors"
            >
              Return to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationDeleted;
